<template>
  <div class="parallel-user-detail">
    <!-- 搜索区域 -->
    <a-card :bordered="false" class="search-card">
      <template slot="title">
        <span style="font-weight: bold;">漏损自动统计分析 / {{ zoneName }}</span>
      </template>
      <template slot="extra">
        <a-button @click="$emit('back')" type="primary">返回</a-button>
      </template>
      <div class="table-page-search-wrapper">
        <a-form layout="horizontal">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="查询时间" :labelCol="{ span: 5 }" :wrapperCol="{ span: 19 }">
                <a-range-picker v-model="query.dateRange" style="width: 100%" format="YYYY-MM-DD"
                  :placeholder="['开始时间', '结束时间']" />
              </a-form-item>
            </a-col>
            <a-col :md="16" :sm="24">
              <a-button type="primary" @click="handleQuery">查询</a-button>
              <a-button style="margin-left: 8px" @click="handleReset">重置</a-button>
              <a-button type="primary" style="margin-left: 8px" @click="handleExport">导出</a-button>
            </a-col>
          </a-row>
        </a-form>
      </div>
    </a-card>

    <!-- 表格区域 -->
    <a-card :bordered="false" class="table-card">
      <div class="table-title">{{ record.level || '三级' }}分区—平行大用户明细</div>
      <a-table :columns="columns" :data-source="tableData" :pagination="false" :loading="loading" rowKey="date"
        :scroll="{ x: 'max-content' }" bordered size="middle">
      </a-table>
    </a-card>
  </div>
</template>

<script>
import moment from 'moment'
import axios from 'axios'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import storage from 'store'
export default {
  name: 'ParallelUserDetail',
  props: {
    record: {
      type: Object,
      default: () => ({})
    },
    initialDateRange: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      loading: false,
      query: {
        dateRange: []
      },
      tableData: [],
      columns: []
    }
  },
  computed: {
    zoneName () {
      const name = this.record.zoneName || this.record.areaName
      const level = this.record.level || this.record.areaLevel || '三级'
      return name ? `${level}分区-${name}` : '分区漏损明细'
    }
  },
  created () {
    if (this.initialDateRange && this.initialDateRange.length === 2) {
      this.query.dateRange = this.initialDateRange
    } else {
      this.query.dateRange = [moment().subtract(6, 'days'), moment()]
    }
    this.handleQuery()
  },
  methods: {
    moment,
    handleQuery () {
      if (!this.query.dateRange || this.query.dateRange.length !== 2) {
        this.$message.warning('请先选择查询时间')
        return
      }

      this.loading = true
      const params = {
        zoneId: this.record.id || this.record.zoneId,
        bgeinDate: this.query.dateRange[0].format('YYYY-MM-DD'),
        endDate: this.query.dateRange[1].format('YYYY-MM-DD')
      }

      // 假设使用平行大用户明细的接口，这里先用原来的接口或者新的接口路径
      // 如果是新接口，请修改 url
      this.$http.get('/zone-metering/leakage/level/rule/select/biguser/date', { params }).then(({ data }) => {
        if (data) {
          const list = Array.isArray(data) ? data : (data.list || [])
          if (list.length > 0) {
            this.buildColumns(list[0])
            this.tableData = this.processTableData(list)
          } else {
            this.tableData = []
            this.columns = []
          }
        } else {
          this.tableData = []
        }
      }).catch(err => {
        console.error('查询详情失败:', err)
        this.$message.error('查询详情失败')
      }).finally(() => {
        this.loading = false
      })
    },
    handleReset () {
      if (this.initialDateRange && this.initialDateRange.length === 2) {
        this.query.dateRange = this.initialDateRange
      } else {
        this.query.dateRange = [moment().subtract(6, 'days'), moment()]
      }
      this.handleQuery()
    },
    handleExport () {
      this.loading = true
      const token = storage.get(ACCESS_TOKEN)
      const params = {
        zoneId: this.record.id || this.record.zoneId,
        bgeinDate: this.query.dateRange[0].format('YYYY-MM-DD'),
        endDate: this.query.dateRange[1].format('YYYY-MM-DD')
      }

      axios({
        url: process.env.VUE_APP_API_BASE_URL + 'zone-metering/leakage/level/rule/biguser/export',
        method: 'get',
        params: params,
        responseType: 'blob',
        headers: {
          Authorization: token
        }
      }).then(res => {
        const blob = new Blob([res.data], { type: 'application/vnd.ms-excel' })
        const fileName = '平行大用户明细.xlsx'
        if ('download' in document.createElement('a')) { // 非IE下载
          const elink = document.createElement('a')
          elink.download = fileName
          elink.style.display = 'none'
          elink.href = URL.createObjectURL(blob)
          document.body.appendChild(elink)
          elink.click()
          URL.revokeObjectURL(elink.href) // 释放URL 对象
          document.body.removeChild(elink)
        } else { // IE10+下载
          navigator.msSaveBlob(blob, fileName)
        }
        this.$message.success('导出成功')
      }).catch(err => {
        console.error('导出失败:', err)
        this.$message.error('导出失败')
      }).finally(() => {
        this.loading = false
      })
    },
    buildColumns (firstRow) {
      if (!firstRow) return

      const baseColumns = [
        {
          title: '时间',
          dataIndex: 'date',
          width: 120,
          fixed: 'left',
          align: 'center'
        },
        {
          title: '售水量 (m³)',
          dataIndex: 'sellWater',
          width: 120,
          align: 'center'
        }
      ]

      const userChildren = []
      // 数据源中是 bigUerWaterList
      if (firstRow.bigUerWaterList && Array.isArray(firstRow.bigUerWaterList)) {
        firstRow.bigUerWaterList.forEach((item, index) => {
          userChildren.push({
            title: item.waterName || `用户${index + 1}`,
            dataIndex: `user_${index}`,
            width: 150,
            align: 'center'
          })
        })
      }

      // 添加合计列 (bigUserWaterCount)
      userChildren.push({
        title: '合计',
        dataIndex: 'bigUserWaterCount',
        width: 120,
        align: 'center'
      })

      const waterMeterColumns = {
        title: '用水表',
        children: userChildren
      }

      this.columns = [
        ...baseColumns,
        waterMeterColumns
      ].filter(Boolean)

      // 移除最后一列的宽度，让其自适应以撑满容器，防止固定列右侧出现空白
      if (this.columns.length > 0) {
        const removeLastWidth = (cols) => {
          const lastCol = cols[cols.length - 1]
          if (lastCol.children && lastCol.children.length > 0) {
            removeLastWidth(lastCol.children)
          } else {
            delete lastCol.width
          }
        }
        removeLastWidth(this.columns)
      }
    },
    processTableData (list) {
      console.log('list', list)
      return list.map(item => {
        const row = { ...item }
        if (item.bigUerWaterList && Array.isArray(item.bigUerWaterList)) {
          item.bigUerWaterList.forEach((user, index) => {
            row[`user_${index}`] = user.waterCount
          })
        }
        return row
      })
    }
  }
}
</script>

<style lang="less" scoped>
.parallel-user-detail {
  .search-card {
    margin-bottom: 16px;
  }

  .table-card {
    .table-title {
      text-align: center;
      font-size: 16px;
      font-weight: bold;
      margin-bottom: 16px;
    }
  }
}
</style>